module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h2', [_vm._v("Gift vouchers are available for all classes")]), _vm._v(" "), _c('img', {
    staticClass: "gift-card",
    attrs: {
      "src": _vm.cardImage,
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action"
  }, [_c('a', {
    attrs: {
      "href": "https://shop.hatopress.net/products/gift-card",
      "target": "_blank"
    }
  }, [_vm._v("Buy Now")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35e81d6f","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gift.vue
// module id = 209
// module chunks = 1